'use string';

import {
    addFloorOrdinalSuffix,
    enableSwitcherBtns,
    findSelectionAndCrmData,
    flatClick, getFieldsFromAPI, isBetaResourcesFolder, isCompareMode, isNumeric, isRoofExists,
    makeStringNumbersStrong,
    moveAroundTheFloors,
    numberWithCommas,
    rotation_to_flat, setCSSVar,
    userPrevent,
} from '../../../functions';
import { CardTypes, ViewMode } from '../../../common';
import {
    Buildings,
    cardsData, components,
    GSAPAnimationMixer,
    isDesktop,
    isMobile, isNoMenu,
    projectMode,
    settingsData,
    UIRoot
} from '../../../settings';
import {addFavoritesBlock, addPriceBlock, applyTowerNameNamingRule} from "../cardsFunctions";
import {moveElements, rightNavMenuZIndexChange} from "../../menu/navigation/right-nav-bar";
import {
    closeUnitCardAnimation,
    createUnitCardAnimation,
    dragUnitCard,
    openAndCloseMobileOptionsCard, restorePreviouslyUnitCardPosition,
    unitCardOpenAnimation
} from "../cardsAnimation";
import {openOptionsCard, setOptionsCardPlansBlockHeight} from '../optionsCards';
import { Prepayment } from "../../components/Prepayment/Prepayment";
import {
    changeLangToCurrent,
    getCurrentLang,
    getCurrentLangDirection, getLanguagesTranslations,
} from '../../components/langSwitcher/langSwitcher';
import {dataArrayOfFlat, facingDictionary} from "../cardsConfig";
import {
    changeActiveCardWhenBuildingClick, openSearchHandler,
    toggleResultsList,
} from '../../menu/search/search';
import {hideTooltip} from "../../components/flatTooltip/flatTooltip";
import {isOrbitControlsEnabled} from "../../controls/orbitControls";
import {bombButtonInitActionHandler} from "../../controls/destroyBuilding";
import { renderUpdateValuesOnDemand } from '../../../app';
import {SwipeScript} from "../../controls/swipe";
import {UnitCardClass} from "./UnitCardClass";
import {selectionBoxesSetStatusColor} from "../../threejs/raycast";
import {
    createCompareCardsButton,
    updateCompareButtonOffset,
} from '../../menu/navigation/compareButton';
import {setLordIcon} from "../../../lordicon";
import { Amenities } from '../../components/Amenities/Amenities';
import { analytics } from '../../analytics/analytics';
import { SocialMedia } from '../../components/share/Share';
import {Button} from "../../interfaces/buttons/Button";
import {ExploreButton} from "../../interfaces/buttons/Specific/ExploreButton";
import {BaseElement} from "../../interfaces/BaseElement";
import { Cloudflare } from '../../api/Cloudflare';
import * as PANOLENS from "panolens";
import gsap from 'gsap';
import { BmbyMode } from '../../mode/BmbyMode';

export function createUnitCard(data) {
    const prevCard = UnitCardClass.findCard();
    Panorama.disableAll();

    if (prevCard?.html && cardsData.multiplyCards) {
        prevCard.html.classList.remove('active');
        prevCard.html.classList.add('non-active');
    }

    const card = new BaseElement()
        .addClass(`${CardTypes.Unit}-card`, 'card', 'non-canvas', !isMobile && (settingsData.activeViewMode === ViewMode.FloorPlan) ? 'unit-card--small' : null)
        .addAttribute('data-engineId', data.engineId)
        .appendTo(UIRoot, 'beforeend')
        .DOMElement;

    analytics('unit card',data);
    data.setNode(card);
    data.setFunctionsToMultiCards(card);
    data.setFunctionsToMobileCard();
    setDataToUnitCard(card, data);
    data.setFunctionsToWebCard();

    if (UnitCardClass.cards.length > 1 && cardsData.multiplyCards)
        UnitCardClass.cards.forEach(card => { card.html.classList.add('unit-card--small') });

    data.setAnimationsToCard();

    if (UnitCardClass.cards.length > 1 && cardsData.multiplyCards)
        createCompareCardsButton();

    if (settingsData.buildingDestroyed && !cardsData.multiplyCards)
        card.querySelector('.unit-card__compare-btn').click();

    // document.querySelector(':root').style.setProperty('--left-bar-bottom-move', "264px");
    // setCSSVar('--left-bar-bottom-move', '264px')

    return card;
}

export const updateUnitCard = (data) => {
    let card = UnitCardClass.findCard();

    if (cardsData.multiplyCards) {
        card = UnitCardClass.findCard(false, 'active');

        // if (settingsData.buildingDestroyed)
        //     data.setKeyPlanButtonState(UnitCardClass.findCard(false, 'non-active').html);
    }
    UnitCardClass.cards = UnitCardClass.cards.filter(cardInst => {
        const id = card.html.getAttribute('data-engineid');
        projectMode.Cylinder.cylinderBuildingLabels.markLabel(id,'close');
        return cardInst.engineId !== id;
    });

    analytics('unit card',data);
    card.html.setAttribute('data-engineId', `${data.engineId}`);
    card.html.innerHTML = '';

    // if (isMobile) {
    //     const spoiler = new BaseElement()
    //       .addClass(`${CardTypes.Unit}-card__spoiler`)
    //       .appendTo(card.html);
    //
    //     new Button()
    //       .addClass(
    //         `${CardTypes.Unit}-card__back-button`,
    //         'button',
    //         getCurrentLangDirection() === 'rtl' ? 'icon-right1' : 'icon-left1',
    //         'no-select'
    //       )
    //       .event('click', spoilerBackButtonClickHandler)
    //       .appendTo(spoiler.DOMElement);
    // }

    data.setNode(card.html);
    data.setFunctionsToMobileCard();
    setDataToUnitCard(card.html, data);
    data.setFunctionsToWebCard();
    data.setFunctionsToMobileCard();
    data.setFunctionsToMultiCards(card.html);

    return card.html;
};

export function updateUnitCardProps (unitCardScope,props) {
    let apartmentProps;
    if (props) {
        apartmentProps = props;
    } else {
        apartmentProps = findSelectionAndCrmData(unitCardScope.engineId).crmDataOfFlat;
    }

    unitCardScope.price = apartmentProps.salePrice;
    unitCardScope.status = apartmentProps.status;
    unitCardScope.html.innerHTML = '';
    unitCardScope.setNode(unitCardScope.html);
    unitCardScope.setFunctionsToMobileCard();
    setDataToUnitCard(unitCardScope.html, unitCardScope);
    unitCardScope.setFunctionsToWebCard();
    unitCardScope.setFunctionsToMobileCard();
    unitCardScope.setFunctionsToMultiCards(unitCardScope.html);
}

const setDataToUnitCard = (card, data) => {
    const previewPicBlock = !isMobile && new BaseElement()
        .addClass(`${CardTypes.Unit}-card__preview-block`, 'card__preview-block')
        .appendTo(card)
        .DOMElement;
    const cardBoxWrapper = new BaseElement()
        .addClass(`${CardTypes.Unit}-card__wrapper`, 'card__wrapper')
        .appendTo(card)
        .DOMElement;

    createHeader(data, cardBoxWrapper);
    addInfopointsBlock(data.infoPoints, cardBoxWrapper);

    setImageType(data, previewPicBlock, CardTypes.Unit);

    addAdditionalButtons({card, data, cardType: CardTypes.Unit});

    if (!isMobile) {
        new Button()
          .addClass(`${CardTypes.Unit}-card__close-button`, 'close-button-cross')
          .event('click', closeHandler)
          .appendTo(card);
        createCardSwitchers(data, card);
        addButtons(cardBoxWrapper, data);
        clickToPreview2D(previewPicBlock, data);
        disableArrowButtons();
    }

    data.html = card;
};

export function setImageType(data, previewPicBlock, cardType) {
    let previewUrl = '';
    if (cardType === CardTypes.MobileCard)
        data.plans = data.assets;

    if (data.plans.gallery?.length) {
        previewUrl = '';
    } else if (data.plans.tours360) {
        previewUrl = data.plans.tours360;
    } else if (data.plans.sample360) {
        previewUrl = data.plans.sample360;
    } else {
        const randomTour = Buildings.getActiveBuilding()
            .getInfo()?.crm_data.filter(el => el.assets.tours360 && !el.assets.gallery.length) || [];
        if (randomTour.length)
            previewUrl = randomTour[0].assets.tours360;
    }

    if (previewPicBlock) {
        if (!isMobile && config.features.apartments?.panorama && isTourHasCorrectDomain(previewUrl)) {
            setPanoramaToUnitCardPreview(previewUrl, previewPicBlock);
        } else if (config.features.apartments?.vantagePreview && !data.plans.preview2D) {
            const vantageFolder = isBetaResourcesFolder() ? 'vantages3D_beta' : 'vantages3D';
            const previewUrl = `${config.cdnRepository}/${config.projectFolder}/panocontent/${vantageFolder}/${data.buildingEngineId}/${data.engineId}/preview.jpg`;
            const scaledUrl = Cloudflare.resize(previewUrl, {width: 276});
            const previewPicElement = new BaseElement('img')
                .addClass(`${cardType}-card__preview-block_pic`, 'card__preview-block_pic')
                .appendTo(previewPicBlock)
                .addAttribute('src', scaledUrl)
                .event('error', () => addPreview2D(data.plans, previewPicElement))
                .DOMElement;
        } else {
            const previewPicElement = new BaseElement('img')
                .addClass(`${cardType}-card__preview-block_pic`, 'card__preview-block_pic')
                .appendTo(previewPicBlock)
                .DOMElement;
            addPreview2D(data.plans, previewPicElement);
        }
    }
}

export const addAdditionalButtons = (args) => {
    if (isCompareMode() || cardsData.cardMode.isAmenities)
        return;

    const {card, data, cardType} = args;

    const styleClassPrefix = cardType === `${CardTypes.Similar}`
      ? `${CardTypes.Similar}-card`
      : `${cardType}-card`;
    const buttonsParent = isMobile && (cardType === CardTypes.Options || cardType === CardTypes.Unit)
        ? document.querySelector(`.${cardType}-card__spoiler`)
        : card.querySelector(`.${styleClassPrefix}__title-box`);
    const additionalButtonsWrapper = new BaseElement()
        .addClass(`${styleClassPrefix}__additional-buttons-wrapper`, 'card__additional-buttons-wrapper')
        .appendTo(buttonsParent)
        .DOMElement;

    new SocialMedia(additionalButtonsWrapper,'apt')
      .addClass(`${styleClassPrefix}__social-media-btn`);
    if (config.features.apartments.isFavorite)
        addFavoritesBlock(data, additionalButtonsWrapper, cardType);
    if (!isMobile && cardType === 'unit')
        addCompareButtonToUnitCard(additionalButtonsWrapper);
    addAdditionalButtonClassToWrapperChildren(cardType);
};

const addAdditionalButtonClassToWrapperChildren = (cardType) => {
    const buttonsWrappers = [...document.querySelectorAll(`.${cardType}-card__additional-buttons-wrapper`)];
    if (!Boolean(buttonsWrappers))
        return;

    for (let wrapper of buttonsWrappers) {
        const wrapperChildrenCatalogue = [...wrapper.children];
        for (let child of wrapperChildrenCatalogue) {
            child.classList.add(`${cardType}-card__additional-button`, 'card__additional-button');
        }
    }
}

function setPanoramaToUnitCardPreview(url, parent) {
    if (isMobile)
        return;

    const thumbnailNameFileName = '/thumbnail.png';
    const tour360url = url.split('/index');
    tour360url[1] = thumbnailNameFileName;
    const panoramaUrl = tour360url.join('');
    let panorama = Panorama.getScope();

    if (panorama && !cardsData.multiplyCards) {
        panorama.setContainer(parent);
        panorama.load(panoramaUrl);
    } else if (cardsData.multiplyCards && Panorama.getScope(1)) {
        panorama = Panorama.findEmptyScope();
        panorama.setContainer(parent);
        panorama.load(panoramaUrl);
    } else {
       new Panorama(parent,panoramaUrl);
    }
}



function isTourHasCorrectDomain(tourUrl) {
    if (!tourUrl) return false;
    const tourUrlDomain = new URL(tourUrl).hostname;

    return tourUrlDomain === 'dreamsimages.bmby.com';
}

/**
 * HEADER
 */

export const createHeader = (...props) => {
    const [data, cardBoxWrapper, position = 'afterbegin'] = props;
    const cardBoxHeader = new BaseElement()
        .addClass(
            `${CardTypes.Unit}-card__header`,
            'card__header',
            `${settingsData.isConferenceHost && "conference"}`)
        .appendTo(cardBoxWrapper, position)
        .DOMElement;
    const titleBox = new BaseElement()
        .addClass(`${CardTypes.Unit}-card__title-box`, 'card__title-box')
        .appendTo(cardBoxHeader)
        .DOMElement;
    addTitleBlock(data, titleBox);
    const subTitleBox = new BaseElement()
        .addClass(`${CardTypes.Unit}-card__subtitle-box`, 'card__subtitle-box')
        .appendTo(isMobile ? titleBox : cardBoxHeader)
        .DOMElement;

    // if (isMobile)
    //     new ExploreButton('unit-card').appendTo(cardBoxWrapper);



    if (data.selectedProperty) {
        new BaseElement('span')
            .addClass(`${CardTypes.Unit}-card__label`, 'card__label', 'selected-property')
            .addAttribute('data-dictionary', 'selectedProperty')
            .innerHtml(changeLangToCurrent('selectedProperty'))
            .appendTo(cardBoxWrapper);
    }

    if (Buildings.getBuildingsInfoLength() > 1)
        addTowerName(subTitleBox,data);
    
    if (!Buildings.isOneFloorBuilding(data.buildingEngineId))
        addFloor(data.floor, subTitleBox);
    addPriceBlock(data.engineId, cardBoxHeader);
};

const addTitleBlock = (props, cardBox) => {
    const titleBlock = new BaseElement('h3')
        .addClass(`${CardTypes.Unit}-card__title`, 'card__title')
        .appendTo(cardBox)
        .DOMElement;
    const flatNameWrapper = new BaseElement()
        .addClass(`${CardTypes.Unit}-card__flat-name-wrapper`, 'card__flat-name-wrapper')
        .appendTo(
          isMobile
            ? document.querySelector(`.${CardTypes.Unit}-card__spoiler`)
            : titleBlock
        ).DOMElement;
    new BaseElement('span')
        .addClass(`${CardTypes.Unit}-card__title-flat-name`, 'language-string', 'card__title-flat-name')
        .addAttribute('data-dictionary', `${getPropType(props.propType)}`)
        .innerHtml(`${changeLangToCurrent(getPropType(props.propType))}`)
        .appendTo(flatNameWrapper, 'beforeend')
        .DOMElement;
    new BaseElement('span')
        .addClass(`${CardTypes.Unit}-card__title-flat-number`, 'card__title-flat-number')
        .innerHtml(props.propNum)
        .appendTo(flatNameWrapper);
};

export const getPropType = (propType) => {
    switch (propType) {
        case 'Commercial':
            return 'Comm.';
        case 'Villa':
            return 'Villa';
        default:
            return 'Apt.';
    }
};

const addFloor = (floorNum, parent) => {
    const towerNameElement = new BaseElement()
        .addClass(`${CardTypes.Unit}-card__floor-number`, `card__floor-number`)
        .appendTo(parent)
        .DOMElement;

    const isGroundFloor = settingsData.groundFloor.isActive && (parseInt(settingsData.groundFloor.floor) === parseInt(floorNum));
    const towerNameText = isMobile ? 'at floor' : 'floor';
    const floorElement = new BaseElement('span')
        .addClass('language-string')
        .innerHtml(changeLangToCurrent(towerNameText) + ' ')
        .appendTo(towerNameElement, 'beforeend');

    if (isGroundFloor) {
        const fullLabel = settingsData.groundFloor.fullLabel;
        floorElement
          .addAttribute('data-dictionary', fullLabel)
          .innerHtml(changeLangToCurrent(fullLabel));
    } else {
        const floorNumber = new BaseElement('span')
          .addClass(`${CardTypes.Unit}-card__floor-number_num`,'language-string', 'card__floor-number_num', isGroundFloor ? 'hidden' : null)
          .innerHtml(floorNum)
          .appendTo(towerNameElement);
    
        const translationData = getLanguagesTranslations('floor');
        const currentLang = getCurrentLang();
    
        Object.entries(translationData).forEach(([lang,value]) => {
            let floorElementValue = value;
            let floorNumberValue = floorNum;
        
            if (lang === 'en') {
                floorElementValue = addFloorOrdinalSuffix(floorNumberValue);
                floorNumberValue = ' ';
            }
        
            if (lang === currentLang) {
                floorElement.innerHtml(floorElementValue);
                floorNumber.innerHtml(floorNumberValue);
            }
        
            floorElement.addAttribute(`data-lang-${lang}`,floorElementValue);
            floorNumber.addAttribute(`data-lang-${lang}`,floorNumberValue);
        });
    }
};

const addTowerName = (parent,data) => {
    let towerName;
    let building;

    if ((projectMode.LiteMode.isActive() && (projectMode.LiteMode.modeIs('picture') || projectMode.LiteMode.modeIs('empty'))) || config.features.privateHouseMode){
        building = Buildings.getBuilding(data.engineId.split('_')[0]);
        towerName = building.info.towerName;
    } else {
        building = Buildings.getActiveBuilding();
        towerName = building.info.towerName;
    }
    
    // if (config.features.privateHouseMode && Buildings.isOneFloorBuilding(data.engineId))
    //     return;

    if (Array.isArray(towerName))
        towerName = towerName.find(el => el.lang === getCurrentLang()).value;

    // const towerNameElement = new BaseElement()
    //     .addClass(`${CardTypes.Unit}-card__tower-name`, `card__tower-name`)
    //     .appendTo(parent);
    //
    // if (towerName.split(' ').length < 2) {
    //     new BaseElement('span')
    //         .addClass(`${CardTypes.Unit}-card__tower-name_num`, 'language-string')
    //         .addAttribute('data-dictionary', 'building')
    //         .innerHtml(changeLangToCurrent('building'))
    //         .appendTo(towerNameElement.DOMElement, 'beforeend')
    //
    //     new BaseElement('span')
    //         .addClass(`${CardTypes.Unit}-card__tower-name_title`)
    //         .innerHtml(towerName)
    //         .appendTo(towerNameElement.DOMElement);
    // } else {
    //     towerNameElement.innerHtml(towerName);
    // }
    // towerNameElement.innerHtml(makeStringNumbersStrong(towerNameElement.DOMElement.innerHTML));

    applyTowerNameNamingRule(towerName, parent, CardTypes.Unit);

    if (!b.isOneFloorBuilding(data.buildingEngineId))
        new BaseElement()
          .addClass('subtitle-separator')
          .appendTo(parent);
};

/**
 * INFO-POINTS
 */

const addInfopointsBlock = (...props) => {
    if (cardsData.cardMode.isAmenities)
        return;

    const [infoPoints, cardBox] = props;
    const infoPointsBlock = new BaseElement()
        .addClass(`${CardTypes.Unit}-card__info-points`, 'card__info-points')
        .appendTo(cardBox);
    if (isMobile)
      infoPointsBlock.event('click', infoPointsHandler);

    const regExp = /([A-Za-z])\w+/g;
    const measurement = config.localization.area ? config.localization.area : "m2";
    const dictionary = facingDictionary();
    const cardsInfo = dataArrayOfFlat(infoPoints);
    const infoPointsData = cardsInfo.filter(data => {
        if (getFieldsFromAPI.smallCard().indexOf(data.name) !== -1)
            return data;
        // if (config.features.apartments.aptCardFieldsCntOptions.indexOf(data.name) !== -1)
        //     return data;
    });

    infoPointsData.forEach(data => {
        let value;

        data.exceptions
          ? value = data.exceptions[data.data]
          : value = data.data;

        if (parseInt(value) === 0 || value === undefined)
            return;

        if (data.name === 'storages' && Array.isArray(value)) {
            const valueCopy = [ ...value ];
            value = 0;
            valueCopy.forEach(item => {
                value += item.size;
            });
        }

        if (parseInt(value) === 0)
            return;

        const cardContentBlock = new BaseElement()
            .addClass(`${CardTypes.Unit}-card__info-points-block`, 'card__info-points-block')
            .addAttribute('data-block-type', data.name)
            .appendTo(infoPointsBlock.DOMElement);

        const cardContentWrapper = new BaseElement()
            .addClass(`${CardTypes.Unit}-card__info-points-wrapper`, 'card__info-points-block-wrapper')
            .appendTo(cardContentBlock.DOMElement);

        const cardModelName = new BaseElement()
            .addClass(
                `${CardTypes.Unit}-card__info-points-block_data`,
                'card__info-points-block_data',
                `${data.icon}`
            )
            .appendTo(cardContentWrapper.DOMElement);

        const cardModelNameText = new BaseElement('span')
            .addClass(
                `${CardTypes.Unit}-card__info-points-block_data_text`,
                'card__info-points-block_data_text',
                isNumeric(value) ? 'translate-number' : 'language-string')
            .addAttribute('data-dictionary', value)
            .innerHtml(isNumeric(value) ? numberWithCommas(value) : changeLangToCurrent(value))
            .appendTo(cardModelName.DOMElement, 'beforeend')
        if (regExp.test(value))
            cardModelNameText.addStyle('direction', 'ltr');

        const contentSubtext = new BaseElement()
            .addClass(`${CardTypes.Unit}-card__info-points-block_subtitle`, 'card__info-points-block_subtitle')
            .addInnerHtml(`
                <span class="language-string" data-dictionary="${data.name}">
                    ${changeLangToCurrent(data.name).toLowerCase()}
                </span>`)
            .appendTo(cardContentWrapper.DOMElement);

        switch(data.name) {
            case 'area':
            case 'balcony size':
            case 'roof balcony size':
            case 'covered balcony size':
            case 'basement size':
            case 'storages':
                contentSubtext.addInnerHtml(`<span>,</span>`);

                new BaseElement('span')
                  .addClass('language-string', 'card__info-points-block_subtitle-measurement', 'meters')
                  .addAttribute('data-dictionary', measurement)
                  .addInnerHtml(changeLangToCurrent(measurement))
                  .appendTo(contentSubtext.DOMElement, 'beforeend');
                break;
            case 'exposure':
                if (value.length === 0) {
                    cardContentBlock.remove()
                    return;
                }

                cardModelNameText.remove();

                value.forEach(element => {
                    for (let key in dictionary) {
                        if (element === key) {
                            new BaseElement('span')
                              .addClass(
                                `${CardTypes.Unit}-card__info-points-block_data_text`,
                                'card__info-points-block_data_text',
                                'language-string')
                              .addAttribute('data-dictionary',dictionary[key].en + 'Short')
                              .innerHtml(changeLangToCurrent(dictionary[key].en + 'Short'))
                              .appendTo(cardModelName.DOMElement, 'beforeend');
                        }
                    }
                });
                break;
            case 'accessible':
            case 'tenantPrice':
            case 'treatmentRoom':
                cardModelNameText
                  .innerHtml('')
                  .addClass('icon-check-mark');
                break;
            // case 'storages':
            //     if (Array.isArray(value)) {
            //         if (value.length === 0) {
            //             cardContentBlock.remove()
            //             return;
            //         }
            //
            //         const valueCopy = [ ...value ];
            //         value = 0;
            //         valueCopy.forEach(item => {
            //             value += item.size;
            //         });
            //     }
            //
            //     cardModelNameText.innerHtml(value);
            //     break;
            case 'parkings':
                if (Array.isArray(value)) {
                    if (value.length === 0) {
                        cardContentBlock.remove()
                        return;
                    }

                    value = value.length;
                }

                cardModelNameText.innerHtml(value);

                break;
        }
    });

    hideAbsentInConfigUnitCardInfoPoints();
    setInfoPointsLayoutDependsOnChildren(infoPointsBlock.DOMElement);
};

export const setInfoPointsLayoutDependsOnChildren = (infoPoints) => {
    const visibleInfoPoints = [...infoPoints.querySelectorAll('.card__info-points-block:not(.hidden)')];
    visibleInfoPoints.length >= 4 ?
        infoPoints.classList.add('card__info-points--narrow'):
        infoPoints.classList.remove('card__info-points--narrow');
};

export const hideAbsentInConfigUnitCardInfoPoints = () => {
    if (cardsData.cardMode.isAmenities)
        return;

    for (let card of UnitCardClass.cards) {
        const infoPointsBlocks =
          card.html.querySelector(`.${CardTypes.Unit}-card__info-points`).children;
        // hideNeededInfoPoints(infoPointsBlocks);
        for (let block of infoPointsBlocks) {
            if (!getFieldsFromAPI.smallCard().includes(block.getAttribute('data-block-type')))
                block.classList.add('hidden');
        }
    }

    // function hideNeededInfoPoints(infoPointsBlocks) {
    //     for (let block of infoPointsBlocks) {
    //         if (!config.features.apartments.aptCardFieldsCntUnit.includes(block.getAttribute('data-block-type')))
    //             block.classList.add('hidden');
    //     }
    // }
}

export const showPresentInConfigUnitCardInfoPointsInsideApt = () => {
    const infoPointsBlocks = UnitCardClass.findCard().html.querySelector(`.${CardTypes.Unit}-card__info-points`).children;
    for (let block of infoPointsBlocks) {
        if (config.features.apartments.aptCardFieldsCntOptions.includes(block.getAttribute('data-block-type')))
            block.classList.remove('hidden');
    }
}

/**
 * PREVIEW
 */

const addPreview2D = (data, pic) => {
    const width = 270;
    const quality = 100;
    if (!data?.preview2D) {
        if (Array.isArray(data?.gallery) && data?.gallery.length){
            const scaled = Cloudflare.resize(data.gallery[0],{
                width,
                quality
            });
            pic.setAttribute('src',scaled);
        } else if (config.crmProjectSettings.property.settings.previewImg) {
            const scaled = Cloudflare.resize(config.crmProjectSettings.property.settings.previewImg,
              {
                width,
                quality
              });
            pic.setAttribute('src', `${scaled}`);
        } else {
            pic.setAttribute('src', 'img/holder.jpg');
        }
    } else {
        const scaled = Cloudflare.resize(data.preview2D,
          {
              width,
              quality
          });
        pic.setAttribute('src', scaled);
    }
}




const clickToPreview2D = (previewBlock, data) => {
    const accessToEnter = !cardsData.cardMode.isUnavailable ? true : config.crmProjectSettings.property.settings.enterNotForSale;

    if (!accessToEnter) return;

    // const icon = data.plans.tours360 ? 'icon-360' : 'icon-plan-type';
    // previewBlock.classList.add(icon);

    previewBlock.addEventListener('click', previewClickHandler);
};

/**
 * BUTTONS
 */

const addButtons = (cardBox, data) => {
    const buttonBlock = new BaseElement()
        .addClass(`${CardTypes.Unit}-card__button`, 'card__button')
        .appendTo(cardBox);

    const iconKeyPlan = 'icon-floorplan';
    const keyPlanButtonValue = 'Key plan';
    let iconFloorPlan = data.plans.tours360 ? 'icon-360' : 'icon-plan-type';
    const accessToEnter = !cardsData.cardMode.isUnavailable
        ? true
        : config.crmProjectSettings.property.settings.enterNotForSale;

    if (projectMode.LiteMode.isActive() && (projectMode.LiteMode.modeIs('picture') || projectMode.LiteMode.modeIs('empty')))
        buttonBlock.addClass('key-plan__hide');

    if (BmbyMode.active) {
        addBmbyEditButton(data, buttonBlock.DOMElement, CardTypes.Unit, 'beforeend');
    }

    if (accessToEnter) {
        new Button(BmbyMode.active?"Plans":"Explore")
            .addClass(
                `${CardTypes.Unit}-card__button-floor-plan`,
                iconFloorPlan,
                'cards-buttons',
                'button')
            .event('click', floorPlanHandler)
            .appendTo(buttonBlock.DOMElement, 'beforeend')
    }

    const keyPlanButton = new Button(keyPlanButtonValue)
        .addClass(
            `${CardTypes.Unit}-card__button-key-plan`,
            iconKeyPlan,
            'cards-buttons',
            'button')
        .event('click', keyPlanHandlerThrottling)
        .appendTo(buttonBlock.DOMElement, 'beforeend');

    const hasKeyPlan = Boolean(
        settingsData.commonAssets[Buildings.getActiveBuilding().name]
            ?.floorAmenities.filter(group =>  {
                parseInt(group.from) >= parseInt(data.floor) && parseInt(group.to) <= parseInt(data.floor)
        }));

    if ((config.features?.hideKeyPlanButton || !isRoofExists()) || (config.features?.plainKeyPlan && !hasKeyPlan))
        keyPlanButton.addClass('hidden');
};

export function addBmbyEditButton (data,parent,cardType,position,additionalClasses = []) {
    if (BmbyMode.active) {
        new Button('Prop card')
            .addClass(`${cardType}-card__button-floor-plan`, 'bmby-edit', 'cards-buttons','button',`${cardType}-card__button-bmby-btn`,...additionalClasses)
            .event('click',() => {
                const message = {
                    action: 'EditProperty',
                    data: data.bmbyPropID
                };
                window.parent.postMessage(JSON.stringify(message),"*");
            })
            .appendTo(parent, position)
    }
}

export const addCompareButtonToUnitCard = (parent) => {
    const button = new Button()
        .addClass(
            `${CardTypes.Unit}-card__compare-btn`,
            'button',
            'compare-btn',
            cardsData.multiplyCards && 'active')
        .event('click', compareBtnUnitCardHandler, {capture: true})
        .appendTo(parent)

    setLordIcon('compare', button.DOMElement, {
        trigger: 'hover',
        delay: 0,
        stroke: 90
    });
};

/**
 * SWITCH CARDS
 */

const createCardSwitchers = (object, cardBox) => {
    const activeTower = Buildings.getActiveBuilding();
    const sortingCrm = activeTower.info.crm_data.sort((prev, next) => prev.propNum - next.propNum);
    if (sortingCrm.length < 2)
        return;
    
    const switcherBlock = new BaseElement()
        .addClass(`${CardTypes.Unit}-card__switcher-block`, 'card__switcher-block')
        .appendTo(cardBox.querySelector(`.${CardTypes.Unit}-card__preview-block`));

    const prevButton = new Button()
        .addClass(
            `${CardTypes.Unit}-card__switcher-block--prev`,
            `card__switcher-block--prev`,
            'icon-left1')
        .event('click', switchPrevHandler)
        .appendTo(switcherBlock.DOMElement);

    const nextButton = new Button()
        .addClass(
            `${CardTypes.Unit}-card__switcher-block--next`,
            `card__switcher-block--next`,
            'icon-right1')
        .event('click', switchNextHandler)
        .appendTo(switcherBlock.DOMElement);
    
    if (object.propNum === sortingCrm[0].propNum) {
        prevButton.addStyle('opacity', '0');
        prevButton.addStyle('touchAction', 'none');
    } else if (object.propNum === sortingCrm[sortingCrm.length - 1].propNum) {
        nextButton.addStyle('opacity', '0');
        nextButton.addStyle('touchAction', 'none');
    }
};

const switchPrevHandler = (e) => {
    e.stopPropagation();
    switchHandlerThrottling('prev', e);
};

const switchNextHandler = (e) => {
    e.stopPropagation();
    switchHandlerThrottling('next', e);
};

let timerSwitch;
function switchHandlerThrottling(action, e) {
    const target = e;
    if (timerSwitch !== null) {
        clearTimeout(timerSwitch);
    }

    timerSwitch = setTimeout(function() {
        switchBetweenCards(action, target);
    }, 250);
}

const switchBetweenCards = (action, e) => {
    if (userPrevent()) return;

    const card = CardTypes.Unit;
    const engineId = e.target.closest(`.${card}-card`).getAttribute('data-engineid');
    const {activeTower, crmDataOfFlat} = findSelectionAndCrmData(engineId);
    const object = crmDataOfFlat;
    settingsData.doubleClick = false;

    if (settingsData.bombBlock) return;
    if (settingsData.buildingDestroyed) return;

    const unitCards = UnitCardClass.cards;

    const sortingCrm = activeTower.info.crm_data.sort((prev, next) => prev.propNum - next.propNum);
    let newObject;

    /**
     * Found flat by propNum
     */

    const currentObject = sortingCrm.find(item => item.propNum === object.propNum).propNum;
    sortingCrm.forEach((flat, index) => {

        const actionIndex = (action === 'prev') ? index - 1 : index + 1;
        const actionIndexMulti = (action === 'prev') ? index - 2 : index + 2;

        if (flat.propNum === currentObject) {
            newObject = sortingCrm[actionIndex];

            if (cardsData.multiplyCards && newObject.engineId) {
                unitCards.forEach(card => {
                    if (card.html.getAttribute('data-engineid') === newObject.engineId) {
                        newObject = sortingCrm[actionIndexMulti];
                    }
                })
            }
        }
    });

    if (!newObject)
        return;

    let newObjectSelection = activeTower.apartments.find(item => item.name === newObject.engineId);
    setActiveClassHandler(e, newObjectSelection);
    flatClick(newObjectSelection);

    if (document.querySelector('.search__container-main'))
        changeActiveCardWhenBuildingClick(newObjectSelection, true);
};

export const disableArrowButtons = () => {
    if (isMobile)
        return;

    const cardBox = UnitCardClass.cards;

    if (cardBox.length > 0) {
        cardBox.forEach(card => {
            const blockButtons = card.html.querySelector(`.${CardTypes.Unit}-card__switcher-block`);
            if (!blockButtons)
                return;

            if (settingsData.buildingDestroyed || cardsData.multiplyCards ) {
                if (!blockButtons.classList.contains('hide')) {
                    blockButtons.classList.add('hide');
                }
            } else {
                if (blockButtons.classList.contains('hide')) {
                    blockButtons.classList.remove('hide');
                }
            }
        })
    }
};

/**
 * HANDLERS
 */

// async function spoilerBackButtonClickHandler() {
//     await cardsCloseMobile();
//     openSearchHandler();
// }

const infoPointsHandler = (e) => {
    const currentCard = e.target.closest(`.${CardTypes.Unit}-card`);
    const {crmDataOfFlat} = findSelectionAndCrmData(currentCard.getAttribute('data-engineid'));
    crmDataOfFlat['custom-field-source'] = 'info-points';

    openOptionsCard( {object: crmDataOfFlat} );
};

export const floorPlanHandler = (e) => {
    const currentCard = e.target.closest(`.${CardTypes.Unit}-card`) || e.target.closest(`.${CardTypes.Options}-card`);
    const {crmDataOfFlat} = findSelectionAndCrmData(currentCard.getAttribute('data-engineid'));
    crmDataOfFlat['custom-field-source'] = 'floor-plan';

    openOptionsCard( {object: crmDataOfFlat} );
};

let timerKeyPlan;
export function keyPlanHandlerThrottling(e) {
    if (timerKeyPlan !== null)
        clearTimeout(timerKeyPlan);

    timerKeyPlan = setTimeout(function() {
        if (config.features?.plainKeyPlan) {
            const plugMeshOfTheFloor = Buildings.getActiveBuilding().floorsPlug.find(plug => plug.floor === settingsData.lastClickedFlat.userData.floor);
            if (plugMeshOfTheFloor)
                projectMode.FloorPlan.floorAmenities.show(plugMeshOfTheFloor.data);
        } else {
            keyPlanHandler(e);
        }
    }, 250);
}

const keyPlanHandler = (e) => {
    if (isMobile && components.mobileSearch.state === 'opened-fully')
        return;

    let currentCard;
    isMobile
        ? currentCard = e.target.closest('.results-viewer__apartment-card')
        : currentCard = e.target.closest(`.${CardTypes.Unit}-card`);

    if (!isMobile) {
        const compareButton = currentCard.querySelector('.unit-card__compare-btn');
        if (!compareButton.classList.contains('active'))
            compareButton.click();
    }

    hideTooltip();

    if (cardsData.multiplyCards)
        setActiveClassHandler(e, false);

    if (!isOrbitControlsEnabled() || settingsData.bombBlock)
        return;

    if (!isMobile) {
        enableSwitcherBtns(true);
        toggleResultsList('close');
    }

    const {selectedMesh} = findSelectionAndCrmData(currentCard.getAttribute('data-engineid'));
    const floorIndex = selectedMesh.userData.floor;

    if (isMobile) {
        settingsData.lastClickedFlat = selectedMesh;
        settingsData.currentFloor = floorIndex;
        bombButtonInitActionHandler();
    } else {
        const button = currentCard.querySelector(`.${CardTypes.Unit}-card__button-key-plan`);
        if (button.classList.contains('icon-floorplan') && settingsData.buildingDestroyed || cardsData.cardMode.isDoubleCard) {
            moveAroundTheFloors(selectedMesh.userData.crm_data.engineId);
        } else {
            settingsData.lastClickedFlat = selectedMesh;
            settingsData.currentFloor = floorIndex;
            bombButtonInitActionHandler();
        }
    }

    renderUpdateValuesOnDemand();
    rightNavMenuZIndexChange();

    if (!isMobile) {
        if (settingsData.buildingDestroyed) {
            UnitCardClass.cards.forEach(card => { card.html.classList.add('unit-card--small') });
        } else {
            UnitCardClass.cards.forEach(card => { card.html.classList.remove('unit-card--small') });
        }

        if (!cardsData.multiplyCards)
            restorePreviouslyUnitCardPosition();
    }
}

// export function changeKeyButtonState(button, currentCard, previousClass, newClass, innerWord) {
//     if (isMobile && !button) {
//         return;
//     } else {
//         button = currentCard.querySelector(`.${CardTypes.Unit}-card__button-key-plan`);
//     }
//
//     button.classList.remove(previousClass)
//     button.classList.add(newClass);
//     button.innerHTML = changeLangToCurrent(innerWord);
//     button.setAttribute('data-dictionary', innerWord);
// }

const compareBtnUnitCardHandler = (e) => {
    const target = e.target;
    if (target.classList.contains(`${CardTypes.Unit}-card__compare-btn`)) {
        if (e.target.classList.contains('active')) {
            setActiveClassHandler(e);
            UnitCardClass.deactivateMutliCardsMode(target);
        } else {
            UnitCardClass.activateMutliCardsMode(target);
        }
    }
}

export const closeHandler = (e) => {
    const currentCard = e.target.closest(`.${CardTypes.Unit}-card`);
    const currentCardId = currentCard.getAttribute('data-engineid');
    const instancedCard = UnitCardClass.findCard(currentCardId);
    projectMode.Cylinder.cylinderBuildingLabels.markLabel(currentCardId,'close');

    // TODO we do not use unitCards in mobile anymore
    isMobile && settingsData.isLandscape
        ? UnitCardClass.closeMobileCard()
        : instancedCard && instancedCard.closeWebOrDesktopCard(currentCard, currentCardId);

    if (settingsData.activeViewMode === ViewMode.Cylinder && !settingsData.activeModeSwitching)
        Amenities.show(0);
}

export const previewClickHandler = async (e) => {
    e.stopPropagation();

    if (isMobile && e.target.closest('.search-item__explore-button')) {
        const searchResultItem = e.target.closest('.search__result-item');
        const {crmDataOfFlat} =
          findSelectionAndCrmData(searchResultItem.getAttribute('data-engineid'));
        settingsData.lastClickedFlat = {userData: {crm_data: crmDataOfFlat}};

        openOptionsCard({object: crmDataOfFlat, settings: config});

        return;
    }

    const currentCard = document.querySelector(`.${CardTypes.Unit}-card`);
    const preview = currentCard.querySelector(`.${CardTypes.Unit}-card__preview-block`);
    const unitCardExploreButton = document.querySelector('.unit-card__explore-button');
    const {crmDataOfFlat} =
      findSelectionAndCrmData(currentCard.getAttribute('data-engineid'));

    if (e.target === preview || e.target.closest('.unit-card__explore-button') === unitCardExploreButton) {
        setActiveClassHandler(e);
        openOptionsCard({object: crmDataOfFlat, settings: config});
    }
}

// export const toggleCardMainButton = () => {
//     return;
//     if (!isMobile)
//         return;
//
//     const optionsCard = document.querySelector('.options-card');
//     if (optionsCard && !cardsData.cardMode.isAmenities) {
//         ExploreButton.hide('unit-card');
//
//         const unitCardWrapper = document.querySelector('.unit-card__wrapper');
//         const previousButtonsWrapper = unitCardWrapper.querySelector('.unit-card__buttons-wrapper');
//         const buttonsWrapper = previousButtonsWrapper || new BaseElement()
//           .addClass('unit-card__buttons-wrapper')
//           .appendTo(unitCardWrapper)
//           .DOMElement;
//         if (cardsData.cardMode.isAmenities)
//             buttonsWrapper.classList.add('hidden');
//
//         if (!cardsData.cardMode.isAmenities)
//             new Prepayment(buttonsWrapper, settingsData.lastClickedFlat.userData.crm_data);
//         const prevCustomerContactNowButton = document.querySelector('.options-card__customer-contact-now-btn');
//         if (!prevCustomerContactNowButton)
//             new CustomerContactNow('options-card').appendTo(buttonsWrapper);
//             // : CustomerContactNow.showOptionsCardButton();
//         setUnitCardWrapperTemplateGridAreas();
//         setOptionsCardPlansBlockHeight();
//     } else {
//         ExploreButton.show('unit-card');
//         // CustomerContactNow.hideOptionsCardButton();
//     }
// }

export const setUnitCardWrapperTemplateGridAreas = () => {
    const unitCardButtonsWrapper = document.querySelector('.unit-card__buttons-wrapper');
    const amountOfButtons = unitCardButtonsWrapper ? unitCardButtonsWrapper.children.length : 1;
    const singleButtonTemplate = '"header links" "info-points info-points"';
    const multipleButtonsTemplate = '"header header" "links links" "info-points info-points"';
    const template = amountOfButtons > 1 ? multipleButtonsTemplate : singleButtonTemplate;
    // document.querySelector(':root').style.setProperty('--unitCardWrapperTemplateGridAreas', template);
    setCSSVar('--unitCardWrapperTemplateGridAreas', template);
}

export const setActiveClassHandler = (e, switchObj) => {
    e.preventDefault();
    const unitCardList = UnitCardClass.cards;

    if (!e.target.closest(`.${CardTypes.Unit}-card`)) return;
    const target = e.target.closest(`.${CardTypes.Unit}-card`).getAttribute('data-engineid');

    /**
     * Search toggle active class
     */
    const searchItemPrevious = document.querySelector(`.search__result-item.active-card`);
    const searchItem = document.querySelector(`.search__result-item[data-engineid=${target}]`);
    searchItemPrevious && searchItemPrevious.classList.remove('active-card');
    searchItem && searchItem.classList.add('active-card');

    /**
     * remove active class from all cards
     */
    unitCardList.forEach(card => {
        card.html.classList.remove('active');
        card.html.classList.add('non-active');
    });

    /**
     * if click was from switching of cards, change only active card
     */
    if (switchObj) {
        const {selectedMesh} = findSelectionAndCrmData(target);

        if (UnitCardClass.cards.length > 1 || !cardsData.multiplyCards) {
            selectedMesh.userData.isClicked = false;
            selectionBoxesSetStatusColor(selectedMesh, 'hoverOut');
        }

        settingsData.lastClickedFlat = switchObj;
        rotation_to_flat(switchObj);
        switchObj.userData.isClicked = true;
        selectionBoxesSetStatusColor(switchObj, 'click');
        cardsData.multiplyCards && setActiveCard(e.target.closest(`.${CardTypes.Unit}-card`));

        return;
    }

    /**
     * set active class to clicked card
     */
    unitCardList.forEach(card => {
        if (target === card.html.getAttribute('data-engineid')) {
            const {selectedMesh} = findSelectionAndCrmData(target);
            settingsData.lastClickedFlat = selectedMesh;
            cardsData.multiplyCards && setActiveCard(card.html);
        }
    });
}

export const setActiveCard = (card) => {
    card.classList.toggle('non-active');
    card.classList.toggle('active');
}

export const changeUnitCardPosition = () => {
    const unitCard = UnitCardClass.findCard();
    if (isDesktop || !unitCard)
        return;
    const currentDirection = document.querySelector('.aside__container').getAttribute('data-menu-position');
    const id = unitCard.engineId;

    if (isMobile) {
        UnitCardClass.closeMobileCard();
        const {selectedMesh} = findSelectionAndCrmData(id);
        flatClick(selectedMesh);
        selectionBoxesSetStatusColor(selectedMesh, 'click');
        selectedMesh.userData.isClicked = true;
        return;
    }

    function setAndChangeAttributes(fromDirection, toDirection) {
        let position = unitCard.html.style[fromDirection];
        position = (!position) ? unitCard.html.style[toDirection] : position;
        const positionNumber = position.replace('px', '');
        unitCard.html.removeAttribute('style');
        unitCard.html.setAttribute('style', `${toDirection}:${+positionNumber}px`);
    }

    if (unitCard && isDesktop !== '1') {
        currentDirection === 'right'
            ? setTimeout(() => setAndChangeAttributes('right', 'left'), 70)
            : setTimeout(() => setAndChangeAttributes('left', 'right'), 70);
    }
}

// export const changeCardPositionWhenSearchOpen = () => {
//     return;
//     const isDesktopMode = isDesktop;
//     const card = UnitCardClass.findCard();
//     const search = document.querySelector(`.search__container-main`);
//
//     if (isDesktop)
//         return;
//
//     const cardCurrentPosition = card.html.getBoundingClientRect().x;
//     if (search) {
//         const searchWidth = search.getBoundingClientRect().width;
//         const newCardPosition = cardCurrentPosition - searchWidth;
//         card.html.style.left = `${newCardPosition}px`;
//     } else {
//         card.html.style.left = `${window.innerWidth - card.html.getBoundingClientRect().width - 37}px`;
//     }
// }

/**
 * MOBILE FUNC
 */

export const addSwipeListener = () => {
    const cardBox = UnitCardClass.findCard();
    // const accessToEnter = !cardsData.cardMode.isUnavailable ? true : config.crmProjectSettings.property.settings.enterNotForSale;

    SwipeScript(cardBox.html);
}

export const moveCardWhenBuildingDestroyed = () => {
    const card = UnitCardClass.findCard();
    if (!card || isMobile || isDesktop)
        return;

    const navBarContainer = document.querySelector('.right-nav-bar');
    const menu = document.querySelector('.aside__container');
    const menuPosition = menu?.getAttribute('data-menu-position');
    const rtl = document.querySelector('html').getAttribute('dir') === 'rtl';
    const direction = (rtl || menuPosition === 'right') ? 'left' : 'right';
    const currentCardPosition = card.html.style[direction].replace('px', '');
    let cardPosition = currentCardPosition;
    let topPosition = 60;
    let bottomPosition = 60;
    let offsetWidth;

    offsetWidth = rtl
      ? navBarContainer.offsetLeft
      : (window.innerWidth - navBarContainer.offsetLeft) / 2;

    const fsContainer = document.querySelector('.fs__main__container');
    if (settingsData.buildingDestroyed && fsContainer && (currentCardPosition*1.15) <= navBarContainer.clientWidth + offsetWidth)
        cardPosition = parseInt(currentCardPosition, 10) + navBarContainer.clientWidth + offsetWidth + 12;

    if (settingsData.buildingDestroyed && UnitCardClass.cards.length === 2) {
        const cardHeight = parseInt(UnitCardClass.cards[0].html.getBoundingClientRect().height);
        const compareButtonHeight = parseInt(document.querySelector('.compare-button').getBoundingClientRect().height);
        const resultPosition = parseInt(window.innerHeight) / 2 - compareButtonHeight - cardHeight - 15;

        topPosition = bottomPosition = resultPosition;
    }


    // const mixer = GSAPAnimationMixer.getMixer('floorPlan');
    const mixer = GSAPAnimationMixer.registerNewMixer('moveCardWhenBuildingDestroyed');
    if (UnitCardClass.cards.length === 2) {
        const animation = gsap.to([UnitCardClass.cards[0].html, UnitCardClass.cards[1].html],{
            [direction]: `${cardPosition}px`,
        });

        const animationTopCard = gsap.to(UnitCardClass.cards[0].html,{
            top: `${topPosition}px`,
        });

        const animationBottomCard = gsap.to(UnitCardClass.cards[1].html,{
            bottom: `${bottomPosition}px`,
        });

        mixer.addAnimation(animation);
        mixer.addAnimation(animationTopCard);
        mixer.addAnimation(animationBottomCard);

        const compareBtn = UIRoot.querySelector('.compare-button');
        if (compareBtn && parseInt(currentCardPosition) !== parseInt(cardPosition)) {
            const dir = getCurrentLangDirection() === 'rtl' ? 'left' : 'right';
            const buttonOffset = compareBtn.getBoundingClientRect().width / 2;
            const buttonPosition = parseInt(getComputedStyle(compareBtn)[dir]);
            updateCompareButtonOffset(buttonPosition + cardPosition - buttonOffset);
            const animation = gsap.to(compareBtn,{
                [direction]: `${buttonPosition + parseInt(cardPosition, 10) - buttonOffset}px`
            });

            mixer.addAnimation(animation);
        }
    } else if (UnitCardClass.cards.length < 2) {
        const animation = gsap.to(UnitCardClass.cards[0].html,{
            [direction]: `${cardPosition}px`,
        });
        mixer.addAnimation(animation);
    }
    mixer.play();

    // card.html.setAttribute('style', `${!isDesktop ? 'transform: scale(0.95);' : 'transform: scale(1);'} ${direction}:${cardPosition}px`);
    // card.html.setAttribute('style', `${direction}:${cardPosition}px`);
}

// export function moveCardAfterExitingKeyPlan() {
//     const card = UnitCardClass.findCard();
//     if (!card || isMobile || isDesktop)
//         return;
//
//     const langDirection = getCurrentLangDirection();
//     langDirection === 'ltr' ? card.html.style.right = '37px' : card.html.style.left = '37px';
// }

export const removeUnitCardListeners = (currentCard) => {
    const floorPlan = currentCard.querySelector(`.${CardTypes.Unit}-card__button-floor-plan`);
    const keyPlan = currentCard.querySelector(`.${CardTypes.Unit}-card__button-key-plan`);
    const preview = currentCard.querySelector(`.${CardTypes.Unit}-card__preview-block`);
    const prevButton = currentCard.querySelector(`.${CardTypes.Unit}-card__switcher-block--prev`);
    const nextButton = currentCard.querySelector(`.${CardTypes.Unit}-card__switcher-block--next`);
    const closeButton = currentCard.querySelector(`.${CardTypes.Unit}-card__close-btn`);
    const compareButton = currentCard.querySelector(`.${CardTypes.Unit}-card__compare-btn`);

    if (!isMobile) {
        closeButton && closeButton.removeEventListener('click', closeHandler);
        compareButton && compareButton.removeEventListener('click', compareBtnUnitCardHandler);
    }

    floorPlan && floorPlan.removeEventListener('click', floorPlanHandler);
    keyPlan && keyPlan.removeEventListener('click', keyPlanHandlerThrottling);
    preview && preview.removeEventListener('click', previewClickHandler);
    prevButton && prevButton.removeEventListener('click', switchPrevHandler);
    nextButton && nextButton.removeEventListener('click', switchNextHandler);
    currentCard.removeEventListener('click', setActiveClassHandler);
}

/**
 * Class methods
 */

export async function cardsAnimations() {
    if (isMobile) {
        await unitCardOpenAnimation();
    } else {
        createUnitCardAnimation(this);
        setTimeout(() => dragUnitCard(), 1000);
    }
}

export function cardsFunctionsWeb() {
    hideTooltip();
}

export function cardsFunctionsMobile() {
    const unitCard = UnitCardClass.findCard();

    if (unitCard) {
        unitCard.html.removeEventListener('swiped-right', openAndCloseMobileOptionsCard);
        unitCard.html.removeEventListener('swiped-left', openAndCloseMobileOptionsCard);
    }

    addSwipeListener();
    // moveCardWhenBuildingDestroyed();
    rightNavMenuZIndexChange();
    // CLOSE SEARCH
    const searchContainer = document.querySelector('.search__container-main');
    const isMinimized = (searchContainer) ? searchContainer.classList.contains('minimize') : '';
    const rtl = document.querySelector('html').getAttribute('dir') === 'rtl';
    const actionType =
      settingsData.isLandscape ?
        rtl ?
          'swiped-left':
          'swiped-left':
        'swiped-down';
    // if(!isMinimized) {
    //     mobileHandleSearch({type: actionType});
    // }
}

export function cardsCloseWebDesktop(card, id) {
    let currentCard = card;
    let flatData = findSelectionAndCrmData(id);

    removeUnitCardListeners(currentCard);
    closeUnitCardAnimation(currentCard).then(() => {
        Panorama.disableAll();
          // if(isDesktop && UnitCardClass.cards.length > 0)
          //     gsap.to(UnitCardClass.cards[0].html, {duration: 1.8, scale: 1.3, top: 200});
        // if (!settingsData.buildingDestroyed)
        //     UnitCardClass.cards.forEach(card => { card.html.classList.remove('unit-card--small') });
    });

    UnitCardClass.cards = UnitCardClass.cards.filter(
      card => card.engineId !== currentCard.getAttribute('data-engineid')
    );
    const activeSearchItemList = document.querySelectorAll('.search__result-item:not(.similar-item).active');
    activeSearchItemList.forEach(elem => {
        if (elem.getAttribute('data-engineid') === currentCard.getAttribute('data-engineid')) {
            elem.classList.remove('active');
            elem.classList.remove('active-card');
        } else {
            elem.classList.add('active-card')
        }
    });

    flatData.selectedMesh.userData.isClicked = false;
    selectionBoxesSetStatusColor(flatData.selectedMesh, 'hoverOut');

    const compareBtn = document.querySelector(`.compare-button`);
    if (compareBtn)
        compareBtn.remove();

    moveElements();

    // if (settingsData.activeViewMode !== ViewMode.FloorPlan)
    //     searchGetResults();
    setTimeout(() => {
        if (settingsData.buildingDestroyed)
            UnitCardClass.cards[0]?.html.querySelector('.unit-card__compare-btn').click();
    }, 500);

}

export async function cardsCloseMobile() {
    const unitCard = UnitCardClass.findCard();
    if (!unitCard)
        return;
    await closeUnitCardAnimation(unitCard.html);
    projectMode.Cylinder.cylinderBuildingLabels.markLabel(unitCard.engineId,'close');
    Panorama.disableAll();
    removeUnitCardListeners(unitCard.html);
    const activeSearchItem = document.querySelector('.search__result-item:not(.similar-item).active');
    if (activeSearchItem)
        activeSearchItem.classList.remove('active');
    UnitCardClass.cards = [];

    if (cardsData.cardMode.isAmenities && isMobile)
        return;

    const {selectedMesh} = findSelectionAndCrmData(unitCard.engineId);
    if (!selectedMesh)
        return;
    selectedMesh.userData.isClicked = false;
    selectionBoxesSetStatusColor(selectedMesh, 'hoverOut');
}

export function multiCardsLogic(card) {
    if (!cardsData.multiplyCards)
        return;

    card.classList.add('active');

    UnitCardClass.cards.forEach(card => {
        card.html.addEventListener('click', setActiveClassHandler);
    });
}

export function keyButtonState(card) {
    if (!card)
        card = UnitCardClass.findCard()?.html;

    const buttonKeyPlan = card.querySelector(`.${CardTypes.Unit}-card__button-key-plan`);
    if (buttonKeyPlan.classList.contains('icon-right')) {
        buttonKeyPlan.classList.add('icon-floorplan')
        buttonKeyPlan.classList.remove('icon-right');
        buttonKeyPlan.innerHTML = changeLangToCurrent('Key plan');
        buttonKeyPlan.setAttribute('data-dictionary', 'Key plan');
    }
}

export function closeMultiCards(switchBuildings = false) {
    const cardList = UnitCardClass.cards;
    UnitCardClass.deactivateMutliCardsMode();

    cardList.forEach(card => {
        closeUnitCardAnimation(card.html, 'close-all');
        projectMode.Cylinder.cylinderBuildingLabels.markLabel(card.buildingEngineId,'close');

        // HOVER OUT SEARCH

        const activeSearchItemList = document.querySelectorAll('.search__result-item:not(.similar-item).active');
        activeSearchItemList.forEach(elem => {
            if (elem.getAttribute('data-engineid') === card.html.getAttribute('data-engineid')) {
                elem.classList.remove('active');
                elem.classList.remove('active-card');
            } else {
                elem.classList.add('active-card')
            }
        });
    });

    if (!config.features.privateHouseMode) {
        const activeTower = Buildings.getActiveBuilding();
        activeTower && activeTower.apartments.forEach(item => {
            item.userData.isClicked = false;
            selectionBoxesSetStatusColor(item, 'hoverOut', undefined, undefined, switchBuildings);
        });
    }

    UnitCardClass.cards = [];

    const compareBtn = document.querySelector(`.compare-button`);
    if (compareBtn)
        compareBtn.remove();

    moveElements();
}


class Panorama {
    static scopes = [];

    constructor (parent, url) {
        this.parent = parent;
        this.url = Cloudflare.resize(url,{
            width: 300
        });
        this.viewer = new PANOLENS.Viewer( {container: this.parent, controlBar: false, cameraFov: 90} );
        window.removeEventListener( 'resize' , this.viewer.HANDLER_WINDOW_RESIZE, true );
        this.panorama = new PANOLENS.ImagePanorama(this.url);
        this.viewer.add(this.panorama);
        this.viewer.addUpdateCallback(this.rotation.bind(this));
        this.active = true;

        Panorama.scopes.push(this);
    }

    rotation() {
        this.viewer.panorama.rotation.y -= 0.0025;
    }

    stop() {
        window.cancelAnimationFrame(this.viewer.requestAnimationId);
        this.active = false;
    }

    run () {
        this.viewer.animate();
        this.active = true;
    }

    load(url) {
        const resizedUrl = Cloudflare.resize(url,{
            width: 300
        });
        this.panorama.load(resizedUrl);
        this.stop();
        this.run();
    }

    setContainer(container) {
        this.parent = container;
        container.appendChild(this.viewer.renderer.domElement);
    }

    static getScope(index = 0) {
        return Panorama.scopes[index];
    }

    static findEmptyScope() {
        return Panorama.scopes.find(scope => !document.body.contains(scope.parent));
    }

    static disableAll() {
        Panorama.scopes.forEach(scope => {
            if (!document.body.contains(scope.parent)) {
                scope.stop();
            }
        });
    }
}
